import { schemes, zSchema } from "@zeal/common";

export const companyBusinessDocumentItemSchema = zSchema.object({
  key: zSchema.string(),
  last_modified: zSchema.string().optional(),
  size: zSchema.number().optional(),
});

export type TCompanyBusinessDocumentItem = zSchema.infer<
  typeof companyBusinessDocumentItemSchema
>;

export const listCompanyBusinessDocumentsParamsSchema = zSchema.object({
  companyID: schemes.uuid(),
});

export type TListCompanyBusinessDocumentsParams = zSchema.infer<
  typeof listCompanyBusinessDocumentsParamsSchema
>;

export const listCompanyBusinessDocumentsResponseSchema = zSchema.object({
  ein_letter: companyBusinessDocumentItemSchema.optional(),
  additional_documents: zSchema
    .array(companyBusinessDocumentItemSchema)
    .optional(),
  authorized_agent_authorization: companyBusinessDocumentItemSchema.optional(),
});

export type TListCompanyBusinessDocumentsResponse = zSchema.infer<
  typeof listCompanyBusinessDocumentsResponseSchema
>;
